import { HomeItemProp, Song } from "./Interfaces";

export const dummyData: { [name: string]: HomeItemProp[] } = {
    "Shortcuts": [
        {
            image: 'https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fshortcuts%2Fyour-top-songs-2019_DEFAULT-en.jpg?alt=media&token=8890a7cb-d8a5-4cbc-a13b-1f42eac5fe31',
            name: 'Your Top Songs 2019',
            url: "topsongs2019",
            type: "playlist"
        },
        {
            image: 'https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fshortcuts%2F305c7c493ca5c108ade08dea6a169694db911644.jpg?alt=media&token=d1efc482-9cd0-43fe-bad9-eb75f586b76e',
            name: 'Maroon 5',
            url: "maroon5",
            type: "artist"
        },
        {
            image: 'https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fshortcuts%2Fab67706c0000da84cb3551a47c31ec99e71bf414.jpg?alt=media&token=657f6ca5-2230-4c04-8c8b-beb8db1fdd4f',
            name: 'Select Songs',
            url: 'selectsongs',
            type: "playlist"
        },
        {
            image: 'https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fshortcuts%2Fab67706c0000da8418807df7ef3512197a6a9d3c.jpg?alt=media&token=a25bb6a3-00b4-4ee7-aca6-ecdd8e6f67b2',
            name: 'NF Real Music Playlist',
            url: "nfrealmusicplaylist",
            type: "playlist"
        },
        {
            image: 'https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fshortcuts%2Fwrapped-2020-top100_DEFAULT-en.jpg?alt=media&token=e1da462b-da95-408f-baa8-b2c42750984f',
            name: "Your Top Songs 2020",
            url: "topsongs2020",
            type: "playlist"
        },
        {
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fshortcuts%2F55db20d7c49bdcf52162474265c66ca601054b1c.jpg?alt=media&token=20b8641c-a989-4934-adfc-203d0fc8ea16",
            name: "NF",
            url: "nfrealmusic",
            type: "artist"
        }
    ],
    "Recently played": [
        {
            name: "Select Songs",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecent%2Fab67706c0000da84cb3551a47c31ec99e71bf414.jpg?alt=media&token=bfba98bf-4399-4363-b4e9-51e000e525b3",
            url: "selectsongs",
            type: "playlist"
        },
        {
            name: "NF Real Music Playlist",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecent%2Fab67706c0000da8418807df7ef3512197a6a9d3c.jpg?alt=media&token=a1896dc8-1ee3-4fa8-9683-5d143df84d8a",
            url: "nfrealmusicplaylist",
            type: "playlist"
        },
        {
            name: "Liked Songs",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecent%2Fliked-songs-300.png?alt=media&token=f6d2a072-dadc-40a9-b03d-4a1cc5693e77",
            url: "likedsongs",
            type: "playlist"
        },
        {
            name: "NEFFEX",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecent%2F53d2a4963df8ec398819ff49bb3ffb79deda71e0.jpg?alt=media&token=37740a38-a578-45b6-aa44-29b9fd1f1a32",
            url: "neffexplaylist",
            type: "playlist"
        },
        {
            name: "NF",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecent%2F55db20d7c49bdcf52162474265c66ca601054b1c%20(1).jpg?alt=media&token=a3dd2e2e-8e75-48d8-a51d-12632f2df3ff",
            url: "nfplaylist",
            type: "playlist"
        },
        {
            name: "Little Angles",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecent%2F66267eb7d9adffdbb5e01f2b9b52ac5287411ff9.jpg?alt=media&token=33078461-5d27-4da2-943d-71b49dd6c432",
            url: "littleanglesplaylist",
            type: "playlist"
        }
    ],
    "15 minutes or less shows": [
        {
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fpodcasts%2F2cf7bb200a143775f33f4fd70d835d6519189472.jpg?alt=media&token=4f28dfa9-0298-4819-b3c7-c53566371451",
            name: "Zakir Khan",
            type: "podcast",
            url: "zakirkhanpod"
        },
        {
            name: "Based Zeus",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fpodcasts%2F6000e88a881a265a7d957e3eb8da734b428cd6ab.jpg?alt=media&token=04231ecf-6892-4fe7-b9f9-9bf1246fea3f",
            type: "podcast",
            url: "basedzeuspod"
        },
        {
            name: "The Anime Podcast",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fpodcasts%2F5245966b1066de0676d12e1c099c029772a3fcb9.jpg?alt=media&token=2fcec0f3-5d3f-4b34-a458-93760487d4f7",
            type: "podcast",
            url: "animepod"
        },
        {
            name: "Such A Pyaar",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fpodcasts%2Fc9f5740a3702beb413aec93ee1794ba1f41ac03b.jpg?alt=media&token=0df57cbc-d1e1-41b9-900d-ec616687cc54",
            type: "podcast",
            url: "pyaarpod"
        },
        {
            name: "Hack The Shell",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fpodcasts%2F9bebb697efb662653d58091f6cbe351f9fb53b18.jpg?alt=media&token=79422ab5-c1c6-41ed-a092-dcbfbe8ea807",
            type: "podcast",
            url: "shellpod"
        },
        {
            name: "Heedful Things",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fpodcasts%2Fcfb058292ad711cbede587ae3bb76223e4c76057.jpg?alt=media&token=bb6ea364-61d1-4c0f-92c4-d3120066f4b8",
            type: "podcast",
            url: "heedfulpod"
        }
    ],
    "Your 2020 Wrapped": [
        {
            name: "Your Top Songs 2020",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fwrapped%2Fwrapped-2020-top100_DEFAULT-en%20(1).jpg?alt=media&token=5ec5b47a-ef66-4d49-9f98-6ab015f492b6",
            type: "playlist",
            url: "topsongs2020"
        },
        {
            name: "Missed Hits",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fwrapped%2Fwrapped-2020-discovery_DEFAULT-en.jpg?alt=media&token=04d15b07-5b2c-4950-be2b-8765f1c4bb5a",
            type: "playlist",
            url: "missedhits"
        }
    ],
    "Made for GrayHat": [
        {
            name: "Discover Weekly",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmade%2Fdefault.jpg?alt=media&token=daa82bc7-02c8-4d8e-a0f4-6dbcc5633974",
            type: "playlist",
            url: "weekly"
        },
        {
            name: "Daily Mix 1",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmade%2Fdefault%20(1).jpg?alt=media&token=deff8f2d-6981-45ca-84e3-24678dffa16c",
            type: "playlist",
            url: "daily1"
        },
        {
            name: "Daily Mix 2",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmade%2Fdefault%20(2).jpg?alt=media&token=47f396bf-b934-4004-a38a-4851e345237c",
            type: "playlist",
            url: "daily2"
        },
        {
            name: "Daily Mix 3",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmade%2Fdefault%20(3).jpg?alt=media&token=e0a90c3e-fbe0-494e-990c-efe5d67526ad",
            type: "playlist",
            url: "daily3"
        },
        {
            name: "Daily Mix 4",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmade%2Fdefault%20(4).jpg?alt=media&token=4e413de2-4027-461a-8ccc-b289e6afcdb2",
            type: "playlist",
            url: "daily4"
        },
        {
            name: "Daily Mix 5",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmade%2Fdefault%20(5).jpg?alt=media&token=056b91a2-be06-49fc-8d62-b1afd59d5320",
            type: "playlist",
            url: "daily5"
        }
    ],
    "Uniquely yours": [
        {
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Funique%2Ftime-capsule-blue_DEFAULT-en.jpg?alt=media&token=7eded288-c185-48e7-bc57-912f2a4c03ba",
            name: "Time Capsule",
            type: "playlist",
            url: "timecapsule"
        },
        {
            name: "On Repeat",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Funique%2FPZN_On_Repeat_DEFAULT-en.jpg?alt=media&token=dede7505-dfa9-4b3b-b930-db18a114a7ea",
            type: "playlist",
            url: "onrepeat"
        },
        {
            name: "Repeat Rewind",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Funique%2FPZN_Repeat_Rewind_DEFAULT-en.jpg?alt=media&token=923f444d-2dc4-4ae4-af6a-7d82fa835ebd",
            type: "playlist",
            url: "repeatrewind"
        },
        {
            name: "Your Summer Rewind",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Funique%2Fsummer-rewind-2020_DEFAULT-en.jpg?alt=media&token=f15392d3-632a-4004-a81e-e07a48d65a9c",
            type: "playlist",
            url: "summerrewind"
        },
        {
            name: "Liked Songs",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Funique%2Fliked-songs-300.png?alt=media&token=26a2ed5d-6ea9-4935-8584-ee4cd565c747",
            type: "playlist",
            url: "likedsongs"
        },
        {
            name: "Your Top Songs 2019",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Funique%2Fyour-top-songs-2019_DEFAULT-en.jpg?alt=media&token=ff566d00-bc14-446a-a404-369928935041",
            type: "playlist",
            url: "topsongs2019"
        }
    ],
    "More like Anuv Jain": [
        {
            name: "Waqt Ki Baatein - Single",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_anuv%2Fab67616d0000b2735425ed121a059b74e23879dc.jpg?alt=media&token=c1090c75-4abd-4fab-93e8-bad31d0a0254",
            url: "waqtplaylist",
            type: "playlist"
        },
        {
            name: "Believe",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_anuv%2Fab67616d0000b273b8d6290393056a04acee107d.jpg?alt=media&token=f53899cf-1569-47af-a01b-6fce445b6ff8",
            url: "believeplaylist",
            type: "playlist"
        },
        {
            name: "Chillnama",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_anuv%2Fab67706f000000024955500c8726cbc8eae70cbe.jpg?alt=media&token=b4b7ee4e-d20c-475b-bb5b-2ed083eee269",
            url: "chillnamaplaylist",
            type: "playlist"
        },
        {
            name: "Indie India",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_anuv%2Fab67706f000000023ec83c6d8d007be8ac7c991e.jpg?alt=media&token=576af91c-271d-48c1-a1aa-616534f1a066",
            url: "indieaplaylist",
            type: "playlist"
        },
        {
            name: "Shubh Night",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_anuv%2Fab67706f00000002e13150614ad28e673bed02dc.jpg?alt=media&token=e00e4c43-d76b-465c-a4c5-fba31aeccfb5",
            url: "shubhnight",
            type: "playlist"
        },
        {
            name: "The Bollywood Hangover",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_anuv%2Fab67706f00000002a724939443e18ff6d368379d.jpg?alt=media&token=5b25d293-2175-4ec0-977e-5b0ad20f59b6",
            url: "hangoverplaylist",
            type: "playlist"
        }
    ],
    "For Your Listening Pleasure!": [
        {
            name: "Indie Shower Tunes",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fpleasure%2Fab67706f0000000216bc1ca9bf6c12110a81a250.jpg?alt=media&token=98b4ade5-afe4-4852-af62-2dbc5ff01664",
            type: "playlist",
            url: "showertunes"
        },
        {
            name: "Divine Vibes",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fpleasure%2Fab67706f0000000232ef1c95c1c17f044797db72.jpg?alt=media&token=c0a982b2-7ea8-4e9c-bb4c-405b4528465f",
            type: "playlist",
            url: "divinevibes"
        },
        {
            name: "Acoustic Lounge",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fpleasure%2Fab67706f00000002914e9f5d7db1d6b4341d5aef.jpg?alt=media&token=654780eb-1394-4681-b612-20a8d57f981c",
            type: "playlist",
            url: "lounge"
        },
        {
            name: "Dhyanam",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fpleasure%2Fab67706f000000020320889c84be3087df585140.jpg?alt=media&token=1f4d00b8-4269-4a2d-959c-0ac9fac1fbb5",
            type: "playlist",
            url: "dhyanam"
        },
        {
            name: "Workout Bhangra",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fpleasure%2Fab67706f00000002376ef74e2ef4c5c35723cff2.jpg?alt=media&token=44af7eef-62fe-44a5-b092-03e8115c4ca5",
            type: "playlist",
            url: "bhangra"
        },
        {
            name: "Va Velava",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fpleasure%2Fab67706f00000002b0d0b97a2201d889d6d10e89.jpg?alt=media&token=c515e433-7dc6-4a85-96ee-ffb8e6a23cc1",
            type: "playlist",
            url: "velava"
        }
    ],
    "More like Ed Sheeran": [
        {
            name: "Life Sucks",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_ed%2Fab67706f00000002ed5ed2d8f79fbb9b117abd1d.jpg?alt=media&token=d666b69e-3163-422f-8451-9bc8b87b868a",
            type: "playlist",
            url: "likesucks"
        },
        {
            name: "Alone Again",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_ed%2Fab67706f0000000265af49474d91827160b56b27.jpg?alt=media&token=319d2348-ea7d-47d9-b339-e171652e4040",
            type: "playlist",
            url: "aloneagain"
        },
        {
            name: "Top Male Artists of 2019 Indonesia",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_ed%2Fab67706f00000002e9312b9a61f31f4dd99358b3.jpg?alt=media&token=483cf8d4-3b1a-453d-82cf-effbf61b804e",
            type: "playlist",
            url: "male2019indo"
        },
        {
            name: "Why Don't We",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_ed%2F648d13ff6cc48f34d8154894254ff3cf65778cbb.jpg?alt=media&token=dab983c2-3d7d-4e5f-8e2c-8e53259863cd",
            type: "artist",
            url: "whydontwe"
        },
        {
            name: "Mega Hit Mix",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_ed%2Fab67706f00000002db11b346997ff5cc78298028.jpg?alt=media&token=0a573539-4bb0-4c4f-8718-2e9c93b626e5",
            type: "playlist",
            url: "megahitmix"
        },
        {
            name: "Best of the Decade For You",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_ed%2Fab67706f00000002ba77a2166a7b66e9a300ffaa.jpg?alt=media&token=16250991-274b-4719-a076-31367a04e276",
            type: "playlist",
            url: "bestofdecade"
        }
    ],
    "Your favorite albums and songs": [
        {
            name: "Ik Kahani",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Ffav%2Fab67616d0000b2731854beed317a35572b156a0b.jpg?alt=media&token=fb317616-3016-4188-a251-cc00977abb93",
            type: "playlist",
            url: "ikkahani"
        },
        {
            name: "Bareilly Ki Barfi",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Ffav%2Fab67616d0000b27384aa52f0a400ecfd7a30a115.jpg?alt=media&token=c802e0d9-0698-48f2-9f93-6cf5c4e695ef",
            type: "playlist",
            url: "barfi"
        },
        {
            name: "Andhadhun",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Ffav%2Fab67616d0000b273c411e5c8eec8b0e1c5f21b27.jpg?alt=media&token=55dd79b6-8b25-4330-a27f-0c75252f0ddf",
            type: "playlist",
            url: "andhadhun"
        },
        {
            name: "New",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Ffav%2Fab67616d0000b27346f6975761d26f4c43f9b176.jpg?alt=media&token=5d7f7b86-32b9-4879-8534-fbafab44e343",
            type: "playlist",
            url: "newplaylist"
        },
        {
            name: "Sick Boy",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Ffav%2Fab67616d0000b2738e26bf4293c9da7a6439607b.jpg?alt=media&token=55e4ea6d-e548-4034-927e-fe57667001b4",
            type: "playlist",
            url: "sickboy"
        },
        {
            name: "Wave Two",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Ffav%2Fab67616d0000b27300ab67e9425e02715eb4900a.jpg?alt=media&token=633b1a6f-4279-47b8-bd8b-8e6b28a821cf",
            type: "playlist",
            url: "wavetwo"
        }
    ],
    "More like PRETTYMUCH": [
        {
            name: "Mega Hit Mix",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_pretty%2Fab67706f00000002db11b346997ff5cc78298028.jpg?alt=media&token=fec2d4df-58e9-4276-8db2-2f389b1fd347",
            type: "playlist",
            url: "megahitmix"
        },
        {
            name: "Workout",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_pretty%2Fab67706f0000000252a4093409a93d2f13a35f3f.jpg?alt=media&token=38b53862-4762-4396-bae4-2fe142d873b6",
            type: "playlist",
            url: "workout"
        },
        {
            name: "Girl Power Karaoke",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_pretty%2Fab67706f00000002ac6d1bf89ce37d751e9b535a.jpg?alt=media&token=758df3c8-c74b-45fc-a6a3-1e492a4a915c",
            type: "playlist",
            url: "girlpower"
        },
        {
            name: "Girls' Night",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_pretty%2Fab67706f00000002955a83cb4667cf205fdf58eb.jpg?alt=media&token=9da00030-5219-4526-8ae0-7e6dc0a2d0c4",
            type: "playlist",
            url: "girlsnight"
        },
        {
            name: "New Hope Club",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_pretty%2Fab67616d0000b273ecfbf740cbb7193699330f3b.jpg?alt=media&token=03100941-26fb-45ce-a40e-bcbdf02ef1ee",
            type: "playlist",
            url: "newhopeclub"
        },
        {
            name: "I Want You",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_pretty%2Fab67616d0000b273f17eb36e9fbd8625d69bc120.jpg?alt=media&token=88c833d3-7ab8-4c78-8c13-abe91cd68a33",
            type: "playlist",
            url: "iwantyou"
        }
    ],
    "More like NF": [
        {
            name: "Torn Between Pages",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_nf%2Fab67616d0000b2731d132e2756a5ec168595e163.jpg?alt=media&token=1639402a-510a-4b98-8197-9d9bd1daf17b",
            type: "playlist",
            url: "tornpages"
        },
        {
            name: "Still Lost",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_nf%2Fab67616d0000b27353cbb27af7a488a5a342d355.jpg?alt=media&token=70561eb0-7b76-40e0-b8c2-b0fd47fb32c5",
            type: "playlist",
            url: "stillost"
        },
        {
            name: "Nevers Road",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_nf%2Fab67616d0000b27394a9f1bc3c0f766b3d761565.jpg?alt=media&token=a90ceede-af8c-4ae6-a22e-6e7ac2115491",
            type: "playlist",
            url: "roads"
        },
        {
            name: "Losing My Mind",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_nf%2Fab67616d0000b273f9d6b3a14461e8daeb01cd3d.jpg?alt=media&token=fdc085e6-f4eb-4c82-b0cf-78f66e15a03b",
            type: "playlist",
            url: "losingmind"
        },
        {
            name: "Gaming Lounge",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_nf%2Fab67706f000000020ed6ebaaa4c4ac3fb7cebd60.jpg?alt=media&token=94cc13bc-4986-4038-947b-4d0fdd7e0e5d",
            type: "playlist",
            url: "gaming"
        },
        {
            name: "On the Edge",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_nf%2Fab67616d0000b27382a1aec6133b3765210e8f90.jpg?alt=media&token=72e7e801-3ef2-4e8f-a96b-93d102781b07",
            type: "playlist",
            url: "ontheedge"
        }
    ],
    "Best of artists": [
        {
            name: "This Is One Direction",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fbest%2Fab67706f00000002b75cdf3f088c129cc350c0f8.jpg?alt=media&token=0809bc18-c5d9-466a-b241-d94b34a768f7",
            type: "playlist",
            url: "onedirectionplaylist"
        },
        {
            name: "This is Badshah",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fbest%2Fab67706f00000002216a6505947eb6bb24a13aa2.jpg?alt=media&token=5dce80e4-4574-4469-a4ac-3fa6e9efa432",
            type: "playlist",
            url: "badshahplaylist"
        },
        {
            name: "This Is Martin Garrix",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fbest%2Fab67706f000000026cac5751f488923a32f4ee79.jpg?alt=media&token=5c20e9f6-e5f0-4596-8020-e8bcd1bd7bbf",
            type: "playlist",
            url: "martingarrixplaylist"
        },
        {
            name: "This Is Lauv",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fbest%2Fab67706f0000000293e4ea843febfd765756bcbe.jpg?alt=media&token=e298e5c2-b615-4a23-b4d6-4fd057f0691f",
            type: "playlist",
            url: "lauvplaylist"
        },
        {
            name: "This Is The Chainsmokers",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fbest%2Fab67706f000000028d4eaef670bc53dae902a0b6.jpg?alt=media&token=218baaba-05b7-423d-a93d-eadb6e1a0662",
            type: "playlist",
            url: "chainsmokersplaylist"
        },
        {
            name: "This Is Ed Sheeran",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fbest%2Fab67706f00000002dbb5c1e604f43c61ada8951f.jpg?alt=media&token=869a9500-295f-4ce2-9c51-65ebda9838b9",
            type: "playlist",
            url: "edplaylist"
        }
    ],
    "Bollywood Heartbreak": [
        {
            name: 'Pachtaoge (From "Jaani Ve")',
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fheartbreaks%2Fab67616d0000b2735f3fcba817dfe0ec755c1627.jpg?alt=media&token=9618039b-ee8c-4152-908f-bc51da4a2238",
            url: "nothere",
            type: "playlist"
        },
        {
            name: 'Tum Hi Aana (From "Marjaavaan")',
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fheartbreaks%2Fab67616d0000b2736539071e0f1833190a491d4d.jpg?alt=media&token=421d4062-7c6c-4aaf-b2b3-01bb9995734e",
            url: "tumhiaana",
            type: "playlist"
        },
        {
            name: "Aashiqui 2",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fheartbreaks%2Fab67616d0000b273348468c203278d510f0cbc5a.jpg?alt=media&token=18403742-567a-43d9-bf72-07cd7c8a40b4",
            url: "aashiqui2",
            type: "playlist"
        },
        {
            name: "Bollywood Mush",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fheartbreaks%2Fab67706f000000025b0b9b639f7371288ffdaf59.jpg?alt=media&token=8a45534e-3046-4121-8ee6-02c0d7bc0096",
            url: "bollymush",
            type: "playlist"
        },
        {
            name: "Bolly Melancholy",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fheartbreaks%2Fab67706f00000002da52e1805016834c255de807.jpg?alt=media&token=161142bb-4cea-4e8f-b537-04e2dce14258",
            type: "playlist",
            url: "melancholybolly"
        },
        {
            name: "Latest Love Tunes",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fheartbreaks%2Fab67706f00000002e8c4f39edefd04d0db4bed76.jpg?alt=media&token=1f017028-f58c-4723-a003-4a4725a48461",
            type: "playlist",
            url: "lovetunes"
        }
    ],
    "Suggested artists": [
        {
            name: "AJ Mitchell",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fsuggested%2F5ae57df76e7dd5a42eec0a462b4c60c3013de9cb.jpg?alt=media&token=5a72a2df-b6da-400b-bd99-f81cf7a333c2",
            type: "artist",
            url: "ajmitchell"
        },
        {
            name: "Mountenz",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fsuggested%2Fb7813c220f931be38b924a9ab86b3af79fbefb32.jpg?alt=media&token=96512573-3db8-4edb-8287-4a1ffc32ee40",
            type: "artist",
            url: "mountenz"
        },
        {
            name: "James Arthur",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fsuggested%2Fdd8ceb41c23ec3352cfc19df178e7f243d6182e4.jpg?alt=media&token=f79c4d66-cc59-41c1-9f39-1c354a80f210",
            type: "artist",
            url: "jamesarthur"
        },
        {
            name: "Why Don't We",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fsuggested%2F648d13ff6cc48f34d8154894254ff3cf65778cbb.jpg?alt=media&token=c1b2e1ff-f988-4159-91c5-7dcc940855fd",
            type: "artist",
            url: "whydontwe"
        },
        {
            name: "blackbear",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fsuggested%2F87ee7b72bab2721e5a3665aeb48309f411ac6df8.jpg?alt=media&token=e397c08a-a1a2-4f74-a75b-adede5bc8ee4",
            type: "artist",
            url: "blackbear"
        },
        {
            name: "Halsey",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fsuggested%2F1ccc88afcd13131dc35a1bd028922dbc748a55fb.jpg?alt=media&token=96335180-c185-4a52-9ae4-7eeff90f8603",
            type: "artist",
            url: "halsey"
        }
    ],
    "More like Nathan Feuerstein": [
        {
            name: "Forgive Me for My Honesty",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_nathan%2Fab67616d0000b273a6d9a0c2070a9e619d1ac855.jpg?alt=media&token=8da8b0c6-bbac-47c9-ae00-a17b63c71a49",
            type: "playlist",
            url: "forgivehonesty"
        },
        {
            name: "Nathan Feuerstein Radio",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_nathan%2Fen.jpg?alt=media&token=da7cf24f-d908-4b54-9a16-3e9cca2891d0",
            type: "playlist",
            url: "nathanfradio"
        },
        {
            name: "So Alone",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_nathan%2Fab67616d0000b27328bd1d6d43c51048bc1d08e6.jpg?alt=media&token=5e65545a-ccda-45c5-9b38-8802f8103455",
            type: "playlist",
            url: "soalone"
        },
        {
            name: "Nakuu",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_nathan%2Fa0f72baa48b5b25c514a0066844b46ea5122b902.jpg?alt=media&token=db4c251d-3241-4910-98d6-9210b2248ecf",
            type: "artist",
            url: "nakuu"
        },
        {
            name: "Fading Away",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_nathan%2Fab67616d0000b273c10f7bb59c9ebc920866bca0.jpg?alt=media&token=7861b5c2-4b34-4d6d-a40d-10f9a64d384e",
            type: "playlist",
            url: "fadingaway"
        },
        {
            name: "How to Love",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_nathan%2Fab67616d0000b2730bfd54e9ce8ddcde6c2a76b7.jpg?alt=media&token=7656bb5a-cb14-4416-b157-f52be3bceb96",
            type: "playlist",
            url: "howtolove"
        }
    ],
    "Recommended for today": [
        {
            name: "~how i'm feeling~",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecommended%2Fab67616d0000b2736047672696efe2a146cf309e.jpg?alt=media&token=48601066-3a1d-4e1e-8935-003894c9b076",
            type: "playlist",
            url: "howfeeling"
        },
        {
            name: "Turn Back Time",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecommended%2Fab67616d0000b273949cb4d6ff8b7f7f4fdb24e5.jpg?alt=media&token=391afa95-1826-4b9b-94db-d62af6cfa913",
            type: "playlist",
            url: "turnbacktime"
        },
        {
            name: "Manic",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecommended%2Fab67616d0000b2737636e1c9e67eaafc9f49aefd.jpg?alt=media&token=eeb1a2de-9755-4910-b4cf-d6334adb3c8d",
            type: "playlist",
            url: "manicplaylist"
        },
        {
            name: "Missing You - EP",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecommended%2Fab67616d0000b273478621f2e8eae44631ce0813.jpg?alt=media&token=52d2be38-8c58-47d5-96cb-b4a1ea9d9850",
            type: "playlist",
            url: "missingyouep"
        },
        {
            name: "Malibu Nights",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecommended%2Fab67616d0000b273c4dae9528b2a8408f463eb17.jpg?alt=media&token=34aff4fa-8af4-45bc-ae21-8232b9fbc061",
            type: "playlist",
            url: "malibunights"
        },
        {
            name: "lost",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecommended%2Fab67616d0000b2733b524e973b13737390949a4f.jpg?alt=media&token=753cde77-8c3f-4635-b878-959b653c4241",
            type: "playlist",
            url: "lost"
        }
    ],
    "More like The Vamps": [
        {
            name: "Girl Power Karaoke",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_vamps%2Fab67706f00000002ac6d1bf89ce37d751e9b535a.jpg?alt=media&token=74d9dd0d-1624-48b1-b510-5690d02b295b",
            type: "playlist",
            url: "girlpower"
        },
        {
            name: "The Vamps Radio",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_vamps%2Fen.jpg?alt=media&token=c7c5b6a0-e1f3-4bd9-97b5-f7f39369b781",
            type: "playlist",
            url: "vampsradio"
        },
        {
            name: "Best Damn Thing",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_vamps%2Fab67616d0000b273a1ecb7c5e1b581cdafbee93c.jpg?alt=media&token=066c30d1-035c-408c-84d3-1e52a7be2246",
            type: "playlist",
            url: "bestdamnthing",
        },
        {
            name: "Unbelievable",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_vamps%2Fab67616d0000b273e70279cb2c329286f7e95af1.jpg?alt=media&token=bbdea90a-6868-4897-9d73-82446b2b5145",
            type: "playlist",
            url: "unbelievable"
        },
        {
            name: "Talk To Ya - EP",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_vamps%2Fab67616d0000b273f74a26b9b62a6a98e56a84e3.jpg?alt=media&token=30f91597-a346-43e4-8cd9-632e9d69a83f",
            type: "playlist",
            url: "ttyep"
        },
        {
            name: "Best of the Decade For You",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fmore_vamps%2Fab67706f00000002ba77a2166a7b66e9a300ffaa.jpg?alt=media&token=9e046073-b776-41da-8175-561af21db024",
            type: "playlist",
            url: "bestofdecade"
        }
    ],
    "Recommended radio": [
        {
            name: "Khalid Radio",
            type: "playlist",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecommended_radio%2Fen%20(1).jpg?alt=media&token=45b07ed5-ed0d-431f-99ad-d7f8f9c06a2a",
            url: "khalidradio"
        },
        {
            name: "AJ Mitchell Radio",
            type: "playlist",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecommended_radio%2Fen.jpg?alt=media&token=34c2c011-4183-48b2-977b-d11d4407364d",
            url: "ajmitchellradio"
        },
        {
            name: "NF Radio",
            type: "playlist",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecommended_radio%2Fen%20(2).jpg?alt=media&token=06174cc3-1c00-4fa8-b5e3-f78a7e396e42",
            url: "nfradio"
        },
        {
            name: "Gentle Bones Radio",
            type: "playlist",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecommended_radio%2Fen%20(3).jpg?alt=media&token=2b994c82-937c-4eba-9047-e2f7ec6f6782",
            url: "gentlebonesradio"
        },
        {
            name: "benny blanco Radio",
            type: "playlist",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecommended_radio%2Fen%20(4).jpg?alt=media&token=745c1b51-59e4-4948-bec8-e3a8ceb5e72a",
            url: "bennyblancoradio"
        },
        {
            name: "Landon Austin Radio",
            type: "playlist",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Frecommended_radio%2Fen%20(5).jpg?alt=media&token=8d4e2f20-4dbd-43da-aa28-418ade8abe29",
            url: "landonradio"
        }
    ],
    "Stimulate your mind": [
        {
            name: "Dictionary.com's Word Of The Day Podcast",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fstimulate%2F0b50af0657101fea848d236de2170351bdf01c5f.jpg?alt=media&token=e32ea35c-a3d8-4d41-bfd8-3269832aa159",
            url: "dictionaryradio",
            type: "podcast"
        },
        {
            name: "Curiosity Daily",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fstimulate%2F0515a947b4496c30d06c46bf4ced226fe02c41a4.jpg?alt=media&token=93be2184-e2b8-4b06-afda-103789219aaf",
            url: "curiosity",
            type: "podcast"
        },
        {
            name: "7 Good Minutes Daily Self-Improvement Podcast with Clyde Lee Dennis",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fstimulate%2Fbe632fd24032fd7a9f2afec3be3e94ce8ed01d19.jpg?alt=media&token=b506fd43-7816-4b50-9513-22c1c390f695",
            url: "selfimprovement",
            type: "podcast"
        },
        {
            name: "Science Vs",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fstimulate%2F0e121a9a02c17d6703e7c12ba0c704166f9afac9.jpg?alt=media&token=62e85513-c448-466c-9c4c-06fca7e4df33",
            url: "sciencevs",
            type: "podcast"
        },
        {
            name: "Weekly Motivation by Ben Lionel Scott",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fstimulate%2F9daaf33e2fe6b144fc5423ce2bdc19fc3c9190f4.jpg?alt=media&token=a4b8a11b-ecca-4231-9d08-f33394712e44",
            url: "motivationweekly",
            type: "podcast"
        },
        {
            name: "Myths and Legends",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/assets%2Fstimulate%2F2a02c28bf9219c853d77b82bf087b2e871bf66e0.jpg?alt=media&token=af336302-920f-4818-b18a-3d0f48a027cd",
            url: "mythsandlegends",
            type: "podcast"
        }
    ],
};

export const playlistData: { [name: string]: Song[] } = {
    "selectsongs": [
        {
            id: "comethru",
            name: "comethru",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/art%2Fcomethru.jpg?alt=media&token=372e6529-745f-4e7b-a9d3-be885cf2579c",
            playlist: "Select Songs",
            artist: "Jeremy Zucker",
            liked: false
        },
        {
            id: "chasing",
            name: "Chasing_(Demo)",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/art%2Fchasing.jpg?alt=media&token=372e6529-745f-4e7b-a9d3-be885cf2579c",
            playlist: "Select Songs",
            artist: "NF",
            liked: true
        },
        {
            id: "choote",
            name: "Laaree Chootee",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/art%2Fchoote.jpg?alt=media&token=372e6529-745f-4e7b-a9d3-be885cf2579c",
            playlist: "Select Songs",
            artist: "Call",
            liked: false
        },
        {
            id: "dark",
            name: "After Dark",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/art%2Fdark.jpg?alt=media&token=372e6529-745f-4e7b-a9d3-be885cf2579c",
            playlist: "Select Songs",
            artist: "Mr.Kitty",
            liked: true
        },
        {
            id: "hate",
            name: "Hate Myself",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/art%2Fhate.jpg?alt=media&token=372e6529-745f-4e7b-a9d3-be885cf2579c",
            playlist: "Select Songs",
            artist: "NF",
            liked: false
        },
        {
            id: "heart",
            name: "Don't Let It Break Your Heart - Piano Edit",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/art%2Fheart.jpg?alt=media&token=372e6529-745f-4e7b-a9d3-be885cf2579c",
            playlist: "Select Songs",
            artist: "Louis Tomlinson",
            liked: false
        },
        {
            id: "introiii",
            name: "Intro III",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/art%2Fintroiii.jpg?alt=media&token=372e6529-745f-4e7b-a9d3-be885cf2579c",
            playlist: "Select Songs",
            artist: "NF",
            liked: true
        },
        {
            id: "lsome",
            name: "Lose Somebody",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/art%2Flsome.jpg?alt=media&token=372e6529-745f-4e7b-a9d3-be885cf2579c",
            playlist: "Select Songs",
            artist: "Kygo",
            liked: false
        },
        {
            id: "mushroom",
            name: "Mushroom Chocolate (with 6LACK)",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/art%2Fmushroom.jpg?alt=media&token=372e6529-745f-4e7b-a9d3-be885cf2579c",
            playlist: "Select Songs",
            artist: "QUIN",
            liked: false
        },
        {
            id: "neffex",
            name: "Best of Me",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/art%2Fneffex.jpg?alt=media&token=372e6529-745f-4e7b-a9d3-be885cf2579c",
            playlist: "Select Songs",
            artist: "NEFFEX",
            liked: false
        },
        {
            id: "ophelia",
            name: "Ophelia",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/art%2Fophelia.jpg?alt=media&token=372e6529-745f-4e7b-a9d3-be885cf2579c",
            playlist: "Select Songs",
            artist: "The Lumineers",
            liked: true
        },
        {
            id: "splash",
            name: "Splash",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/art%2Fsplash.jpg?alt=media&token=372e6529-745f-4e7b-a9d3-be885cf2579c",
            playlist: "Select Songs",
            artist: "Ty James",
            liked: false
        },
        {
            id: "stop",
            name: "Won't Stop",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/art%2Fstop.jpg?alt=media&token=372e6529-745f-4e7b-a9d3-be885cf2579c",
            playlist: "Select Songs",
            artist: "OneRepublic",
            liked: false
        },
        {
            id: "young",
            name: "Too Young",
            image: "https://firebasestorage.googleapis.com/v0/b/sinplay-inc.appspot.com/o/art%2Fyoung.jpg?alt=media&token=372e6529-745f-4e7b-a9d3-be885cf2579c",
            playlist: "Select Songs",
            artist: "Louis Tomlinson",
            liked: true
        },
    ]
};